import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { Unit10RoutingModule } from './unit-10-routing.module';


@NgModule({
  imports: [CommonModule, ReactiveFormsModule, Unit10RoutingModule],
  declarations: [Unit10RoutingModule.components]
})

export class Unit10Module { }
